import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment'; 
import withStyles from '@mui/styles/withStyles';
import {Link, Paper, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, Typography} from '@mui/material';

import ResellerPaymentSourceIssueFetch from './ResellerPaymentSourceIssueFetch';
import BusinessDocumentsFetch from '../kyb/BusinessDocumentsFetch';

const abEnvironment = new AbEnvironment();
const ResellerProblemsQuery = graphql`
query ResellerProblemsQuery($resellerAccountId: UUID!, $activeOnly: Int,  $floatProblemOnly: Int, $outstandingSOOnly: Int, $orderBy: Int, $direction: Int, $first: Int, $offset: Int) {
  accountsearchforcustomer4(reselleraccountid: $resellerAccountId, activeonly: $activeOnly, floatproblemonly: $floatProblemOnly, outstandingsoonly: $outstandingSOOnly, orderby: $orderBy, direction: $direction, first: $first, offset: $offset) {
    totalCount
    nodes {
      accountId
      accountName
      accountNum
      contactLastName
      contactFirstName
      contactEmail
      contactPhone
      accountStatus
      floatProblem
      declineCount
      lastDeclineReason
      lastDeclineChargeAmount
    }
  }
}
`;

const styleSheet = theme => ({
    paper: {
        //marginTop: 32,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
        //paddingTop: 16,
        //paddingLeft: 20,
        //paddingRight: 20,
        //paddingBottom: 20,
        // color: theme.palette.text.secondary,
    },
    rtable: {
      marginTop: 16,
    },
    custlink: {
      marginTop: 4,
      marginBottom: 4,
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 24,
    },
    tblHeadCell: {
      textAlign: 'left',
      verticalAlign: 'bottom',
      borderBottom: 0,
    }
});
  
class ResellerProblems extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      myIssues: [],
      kybIssues: [],
      fundingIssuesLoaded: false,
      kybIssuesLoaded: false,
      dwollaFetchDone: false,
      existingDwollaCust: null,
      certifyOwnersNeeded: null
    };  
  }

  componentWillUnmount() {
    this.mounted = false; // Antipattern workaround
  }

  componentDidMount() {
    this.mounted = true;
    
    const { logError } = this.props.auth;

    let acctId = abEnvironment.getUserAttribute("a_id");
    let dwollaCid = abEnvironment.getUserAttribute("a_dwollaCid");

    //console.log(acctId);
    if (acctId) {
      ResellerPaymentSourceIssueFetch.fetch(acctId).toPromise()
      .then(rpsif => {

        if (rpsif.allPaymentSourceTs && rpsif.allPaymentSourceTs.nodes) {
          let problems = [];
          var i = 0;
          for (i = 0; i < rpsif.allPaymentSourceTs.nodes.length; i++) {

            let ps = rpsif.allPaymentSourceTs.nodes[i];
            if (ps.psStatus === 0 && ps.declineCount > 0) {
              problems.push(ps);
            }

          }
          if (problems.length > 0) {
            if (this.mounted) {
              this.setState({myIssues: problems, fundingIssuesLoaded: true});
            }
          }
        } else {
          if (this.mounted) {
            this.setState({fundingIssuesLoaded: true});
          }
        }
      })
      .catch(err => {
        this.setState({fundingIssuesLoaded: true});
        //only thing to cause this is perhaps outdated DB structure.
        logError('Exception in ResellerProblems.js: ' + err);
      });

      if (! this.mounted) {
        return;
      }
 
      BusinessDocumentsFetch.fetch(acctId).toPromise()
      .then(bdf => {

        //if business is set to verify business, make sure they don't have open items
        if (bdf.accountTByAccountId.achActive === 2) {
          let accountName = abEnvironment.getUserAttribute('a_accountName')
          let ccOnFile = false;
          let problems = [];
          var i = 0;
          for (i = 0; i < bdf.accountTByAccountId.paymentSourceTsByAccountId.nodes.length; i++) {

            let ps = bdf.accountTByAccountId.paymentSourceTsByAccountId.nodes[i];
            if (ps.psType === 0 && ps.psStatus === 0) {
              ccOnFile = true
            }

          }
          if (!ccOnFile) {
            let problem = {accountName: accountName, link : 'fundingsources', issue: 'Backup funding', desc: 'Please enter a backup credit card while ACH provider verifying business'};
            problems.push(problem);
          }

          if (bdf.accountTByAccountId.businessIdentityTsByAccountId.totalCount === 0) {
            localStorage.setItem('settingsTabVal', 1);
            let url = 'settings';
            let problem = {accountName: accountName, link : url, issue: 'ACH documentation', desc: 'ACH provider needs your business information.  Select the link to the left and click Verify Business.'};
            problems.push(problem);

          }

/*
          if (bdf.accountTByAccountId.businessIdentityTsByAccountId.totalCount === 0) {

            if (bdf.accountTByAccountId.businessIdentityTByBiId.businessType !== 'soleProprietorship') {
              if (!bdf.accountTByAccountId.businessIdentityTByBiId.beneficialOwnerTsByBiId || bdf.accountTByAccountId.businessIdentityTByBiId.beneficialOwnerTsByBiId.totalCount === 0) {
                let biId = bdf.accountTByAccountId.businessIdentityTsByAccountId.nodes[0].biId
                let url = 'businessidentityedit?biId' + biId  + '&dId=' + bdf.accountTByAccountId.dwollaCid;
                let problem = {accountName: accountName, link : url, issue: 'ACH documentation', desc: 'ACH provider needs your business owners documented'};
                problems.push(problem);
                }
            }
          }
*/
          let biId = null;
          if (bdf.accountTByAccountId.businessIdentityTsByAccountId.nodes[0]) {
            biId = bdf.accountTByAccountId.businessIdentityTsByAccountId.nodes[0].biId
          }
          if (this.mounted) {
            this.getDwollaCust(dwollaCid, biId, bdf, problems);
          }
          //this.setState({kybIssues: problems, kybIssuesLoaded: true});
        } else {
          if (this.mounted) {
            this.setState({kybIssuesLoaded: true});
          }
        }
      })
      .catch(err => {
        //only thing to cause this is perhaps outdated DB structure.
        if (this.mounted) {
          this.setState({kybIssuesLoaded: true});
        }
        logError('Exception in ResellerProblems.js: ' + err);
      });
    }
  }

  getDwollaCust(dwollaCId, biId, results, problems) {
    const { callPartnerApi, logError } = this.props.auth;
 
    let aPjwt = abEnvironment.getPjwt();
    let accountName = abEnvironment.getUserAttribute('a_accountName')
 
    if (dwollaCId) {
      //retrieve for customer
      let payload = {
        operation: "getDwollaCustomer",
        params: {
          pJwt:      aPjwt,
          dwollaCId: dwollaCId
        }
      };
  
      callPartnerApi('appbind/generic',
                     'POST',
                     payload
      ).then(resp => {
        return resp.json();
      }).then(data => {

        let sendDwollaNeeded = true;
        let uploadDwollaNeeded = false;
        if (data.body.id && (data.body.status === 'document' ||  data.body.status === 'suspended')) {
          sendDwollaNeeded = false;
        }
        if (data.body.id && (data.body.status === 'document')) {
          uploadDwollaNeeded = true;
        }
        if (data.body.id && (data.body.status === 'verified')) {
          sendDwollaNeeded = false;
        }

        let url = '';
        if (sendDwollaNeeded && (results.accountTByAccountId.businessIdentityTsByAccountId.totalCount !== 0)) {
          if (dwollaCId) {
            url = 'businessidentityedit?biId=' + biId + '&dId=' + dwollaCId;
          } else {
            url = 'businessidentityedit?biId=' + biId;
          }
          let problem = {accountName: accountName, link : url, issue: 'ACH documentation', desc: 'ACH provider needs your business information sent to them.  Select the link to the left and click Send to ACH Partner.'};
          problems.push(problem);

        } else if (uploadDwollaNeeded) {

          if (dwollaCId) {
            url = 'businessidentityedit?biId=' + biId + '&dId=' + dwollaCId;
          } else {
            url = 'businessidentityedit?biId=' + biId;
          }
          let uploadInstructions = '';
          if (data.body.businessType === 'soleProprietorship') {
            uploadInstructions = 'ACH provider needs one or more of the following, as applicable to your sole proprietorship: Fictitious Business Name Statement; Certificate of Assumed Name; Business License; Sales/Use Tax License; Registration of Trade Name; EIN documentation (IRS-issued SS4 confirmation letter); Color copy of a valid government-issued photo ID (e.g., a driver’s license, passport, or state ID card).';  
          } else  {
            uploadInstructions = 'ACH provider needs to have your EIN Letter uploaded (IRS-issued SS4 confirmation letter)';
          } 

          let problem = {accountName: accountName, link : url, issue: 'ACH documentation', desc: uploadInstructions};
          problems.push(problem);
        } else {
          let ownersNeeded = false;
          if (data.body._links) {
            if (data.body._links["beneficial-owners"]) {
              if (results.accountTByAccountId.businessIdentityTsByAccountId.nodes[0].beneficialOwnerTsByBiId.totalCount === 0) {
                ownersNeeded = true;
              } else {
                //see if 1 or more owner has been entered but needs to be uploaded.
                var i = 0;
                for (i = 0; i < results.accountTByAccountId.businessIdentityTsByAccountId.nodes[0].beneficialOwnerTsByBiId.totalCount; i++) {
                  let owner = results.accountTByAccountId.businessIdentityTsByAccountId.nodes[0].beneficialOwnerTsByBiId.nodes[i];
                  if (owner.dwollaId === null) {
                    ownersNeeded = true;
                  }
                }
              }
            }
          }

          if (ownersNeeded) {
            if (dwollaCId) {
              url = 'businessidentityedit?biId=' + biId + '&dId=' + dwollaCId;
            } else {
              url = 'businessidentityedit?biId=' + biId;
            }
            let problem = {accountName: accountName, link : url, issue: 'ACH documentation', desc: 'ACH provider needs your business owners documented.'};
            problems.push(problem);
  
          } else {
            let certifyOwnersNeeded = false;
            if (data.body._links) {
              if (data.body._links["certify-beneficial-ownership"]) {
                certifyOwnersNeeded = true;
              }
            }

            if (certifyOwnersNeeded) {
              if (dwollaCId) {
                url = 'businessidentityedit?biId=' + biId + '&dId=' + dwollaCId;
              } else {
                url = 'businessidentityedit?biId=' + biId;
              }
              let problem = {accountName: accountName, link : url, issue: 'ACH documentation', desc: 'ACH provider needs your business owners certified.'};
              problems.push(problem);
  
            }
          }
        }

        if (this.mounted) {
          this.setState({kybIssues: problems, kybIssuesLoaded: true});
        }
      }).catch(reason => {
        if (this.mounted) {
          this.setState({kybIssues: problems, kybIssuesLoaded: true});
        }
        logError('Exception in ResellerProblems.  Failure getting business identity from Dwolla: ' + reason);
      });      

    } else {
      if (this.mounted) {
        this.setState({kybIssues: problems, kybIssuesLoaded: true});
      }
    }
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }
  render() {
      const classes = this.props.classes;

      let accountId = abEnvironment.getUserAttribute('a_id');
      let issueCount = 0;

      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={ResellerProblemsQuery}
          variables={{resellerAccountId: accountId,
                      activeOnly: 1,
                      floatProblemOnly: 1,
                      outstandingSOOnly: 0,
                      orderBy: 0,
                      direction: 1}}
          render={({error, props})=> {

            if (error) {

              return <div>{error.message}</div>

            } else if (props) {

              if (!this.state.kybIssuesLoaded && !this.state.fundingIssuesLoaded) {
                return (null);
              }

              // only show if there is an issue
              if (props.accountsearchforcustomer4.totalCount > 0 || this.state.myIssues.length > 0 || this.state.kybIssues.length > 0) {
                return (
                  <Paper className={classes.paper} elevation={0} >
                    <div >
                      <Typography variant="h6">
                        Issues
                      </Typography>
                      {(props.accountsearchforcustomer4.totalCount + this.state.myIssues.length + this.state.kybIssues.length) === 1 &&
                      <Typography variant="body2">
                          There is {props.accountsearchforcustomer4.totalCount + this.state.myIssues.length + this.state.kybIssues.length} issue requiring your attention.
                      </Typography>
                      }
                      {(props.accountsearchforcustomer4.totalCount + this.state.myIssues.length + this.state.kybIssues.length) > 1 &&
                      <Typography variant="body2">
                          There are {props.accountsearchforcustomer4.totalCount + this.state.myIssues.length + this.state.kybIssues.length} issues requiring your attention.
                      </Typography>
                      }
                      <TableContainer>                      
                        <Table className={classes.rtable}>
                          <TableHead className={classes.tblHead}>
                            <TableRow className={classes.tblHeadRow}>
                              <TableCell className={classes.tblHeadCell}>Account</TableCell>
                              <TableCell className={classes.tblHeadCell}>Issue</TableCell>
                              <TableCell className={classes.tblHeadCell}>Description</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {props.accountsearchforcustomer4.nodes.map(n => {
                              // Determine the issue cause
                              let issueReason = "We're unable to charge a funding source on file for " + n.accountName + ". When there are no working active funding sources,  we may decline subscription charges. Please work with " + n.accountName + " to correct funding source issues and/or add a backup funding source.";
                              if (n.floatProblem > 0 && n.declineCount === 0) {
                                issueReason = n.accountName + " has exceeded their float limit, and subscription charges will be declined.  This can happen when there are too many pending charges, or when a failing payment method has been fixed, but we haven't billed for previous failed charges yet.";
                              }
                              // if decline count > 0, add more to the description if there is a last reason and charge amount.
                              if (n.declineCount > 0) {
                                if (n.lastDeclineReason) {
                                  issueReason = issueReason + '  ' + abEnvironment.getDeclineReason(n.lastDeclineReason);

                                }

                                if (n.lastDeclineChargeAmount) {
                                  let formattedDeclineAmount = Number(n.lastDeclineChargeAmount).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                                  issueReason = issueReason + '  Amount of attempted charge was ' + formattedDeclineAmount;

                                }
                              }

                              issueCount++;
                              let aUrl = "customer?accountId=" + n.accountId + "&fp=Dashboard";
                              return (
                                <TableRow key={issueCount}>
                                  <TableCell>
                                    <Typography variant="body2">
                                      <Link component="button" 
                                            align="left"
                                            variant="body2"
                                            onClick={this.goTo.bind(this, aUrl)}>
                                        {n.accountName}
                                      </Link>
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography variant="body2">{"Payment failure"}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography variant="body2">{issueReason}</Typography>
                                  </TableCell>
                                </TableRow>
                              );
                            })}

                            {this.state.myIssues.map(n => {
                              // Determine the issue cause
                              let issueReason = "We're unable to charge a funding source on file. When there are no working active funding sources,  we may decline subscription charges. ";
                              // if decline count > 0, add more to the description if there is a last reason and charge amount.
                              if (n.declineCount > 0) {
                                if (n.lastDeclineReason) {
                                  issueReason = issueReason + '  ' + abEnvironment.getDeclineReason(n.lastDeclineReason);

                                }

                                if (n.lastDeclineChargeAmount) {
                                  let formattedDeclineAmount = Number(n.lastDeclineChargeAmount).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                                  issueReason = issueReason + '  Amount of attempted charge was ' + formattedDeclineAmount;

                                }
                              }

                              issueCount++;
                              return (
                                <TableRow key={issueCount}>
                                  <TableCell>
                                    <Typography variant="body2">{abEnvironment.getUserAttribute("a_accountName")}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography variant="body2">{"Payment failure"}</Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography variant="body2">{issueReason}</Typography>
                                  </TableCell>
                                </TableRow>
                              );
                            })}

                            {this.state.kybIssues.map(n => {

                              issueCount++;
                              return (
                                <TableRow key={issueCount}>
                                  <TableCell>
                                    
                                    <Link component="button" 
                                          variant="body2"
                                          onClick={this.goTo.bind(this, n.link)}>
                                      {n.accountName}
                                    </Link>
                                 </TableCell>
                                  <TableCell>
                                    <Link component="button" 
                                          variant="body2"
                                          onClick={this.goTo.bind(this, n.link)}>
                                      {n.issue}
                                    </Link>
                                  </TableCell>
                                  <TableCell>
                                    <Typography variant="body2">{n.desc}</Typography>
                                  </TableCell>
                                </TableRow>
                              );
                            })}

                          </TableBody>
                        </Table>
                      </TableContainer>

                    </div>

                  </Paper>
                  
                );  
              }
            }
              
          }}
        />
      );
  }
}

export default withStyles(styleSheet)(ResellerProblems);